import { PlatformProduct } from '../../modules/platform'
import { RootStoreState } from '../root'

export const productSelector = (state: RootStoreState): PlatformProduct | undefined => state.product.selectedProduct